import _ from "lodash";

import {
    POLLS_FETCH_SUCCESS,
    POLLS_FETCH_FAILURE,
    POLLS_SAVE_SUCCESS,
    ARCHIVE_SAVE_SUCCESS,
    ARCHIVE_SAVE_FAILURE,
    FETCH_RESPONSE_REPORT_SUCCESS,
    CLEAR_RESPONSE_REPORT,
} from "../constants/pollConstant";

const upsertPolls = (currentPolls, newPoll) => {
    const updatedPolls = currentPolls && currentPolls?.filter((poll) => poll.id !== newPoll.id);
    updatedPolls.push(newPoll);
    return updatedPolls;
};

const updateStatus = (currentData, newStatus) => {
    const index = _.findIndex(currentData, { id: newStatus.id });
    if (index !== -1) {
        const updatedData = _.cloneDeep(currentData);
        updatedData[index].archived = newStatus.archived;
        return updatedData;
    }
    return currentData;
};

export const initialState = {
    data: [],
    error: null,
    responseReport: []
};

export default (state = initialState, action) => {
    let updatedData;
    switch (action.type) {
        case POLLS_FETCH_SUCCESS:
            return { ...state, data: action.data, error: null };
        case POLLS_FETCH_FAILURE:
            return { ...state, error: action.error };
        case POLLS_SAVE_SUCCESS:
            updatedData = upsertPolls(state.data.data, action.data);
            return { ...state, data: { data: updatedData }, error: null };
        case ARCHIVE_SAVE_SUCCESS:
            updatedData = updateStatus(state.data.data, action.data)
            return { ...state, data: { data: updatedData }, error: null };
        case ARCHIVE_SAVE_FAILURE:
            return { ...state, error: action.error };
        case FETCH_RESPONSE_REPORT_SUCCESS:
            return { ...state, responseReport: action.data.data, error: action.error };
        case CLEAR_RESPONSE_REPORT:
            return { ...state, responseReport: [] }
        default:
            return state;
    }
};
